import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLang } from '@/i18n/LanguageContext';
import MaskLines from '@/components/MaskLines';

export default function About() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const imgY = useTransform(scrollYProgress, [0, 1], ['-6%', '6%']);

  return (
    <section ref={ref} id="about" className="px-5 py-28 md:px-10 md:py-36" data-testid="section-about">
      <div className="grid gap-16 lg:grid-cols-2">
        <div className="self-start lg:sticky lg:top-28">
          <p className="font-mono-label text-[var(--pz-green)]">{t.about.kicker}</p>
          <h2 className="font-display mt-6 text-[10.5vw] leading-[0.9] md:text-[4.8vw]">
            <MaskLines lines={[t.about.lead]} lineClassName="normal-case" />
          </h2>

          <motion.div style={{ y: imgY }} className="relative mt-14 max-w-sm" data-testid="about-photo">
            <div aria-hidden="true" className="absolute -left-3 -top-3 h-full w-full border border-[var(--pz-green)]" />
            <img
              src="/assets/alberto.webp"
              alt="Alberto Scotta durante una presentazione"
              loading="lazy"
              className="relative w-full object-cover"
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% 94%, 0 100%)' }}
            />
          </motion.div>
        </div>

        <ol>
          {t.about.steps.map((step, i) => (
            <li key={step.id} className="border-t hairline py-8 last:border-b md:py-10" data-testid={`about-step-${step.id}`}>
              <span className="font-mono-label text-white/40">{String(i + 1).padStart(2, '0')}</span>
              <h3 className={`font-display mt-3 text-4xl md:text-[3.8vw] 2xl:text-6xl ${step.id === 'panoz' ? 'text-[var(--pz-green)]' : ''}`}>
                <MaskLines lines={[step.word]} />
              </h3>
              <p className="font-mono-label mt-4 text-white/55" style={{ textTransform: 'none', letterSpacing: '0.06em' }}>
                {step.d}
              </p>
              {step.id === 'panoz' && (
                <img
                  src="/assets/firma-black.webp"
                  alt="Firma di Alberto Scotta"
                  loading="lazy"
                  className="mt-8 h-20 w-auto md:h-28"
                  style={{ filter: 'invert(1)' }}
                  data-testid="about-signature"
                />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
